export const HOME_ROUTE_PATH = '/';

enum ROUTE_NAMES {
    LOGIN_MAIN = 'login',
    LOGIN_FULL = 'loginFull',
    LOGIN_SSO = 'loginSso',
    CUE_ENTRYPOINT = 'cueEntrypoint',
    CUE_LOGIN = 'cueLogin',
    CUE_ACTIVITY_VIEW = 'cueActivityView',
    CUE_ACTIVITY_WAITING = 'cueActivityWaiting',
    CUE_ACTIVITY_INFORMATING = 'cueActivityInformating',
    CUE_ACTIVITY_TIMER = 'cueActivityTimer',
    CUE_ACTIVITY_EVALUATING = 'cueActivityEvaluating',
    CUE_ACTIVITY_FINISHING = 'cueActivityFinishing',
    CUE_TRACK_COMPLETED = 'cueTrackCompleted',
    HOME = 'home',
    /* observe */
    OBSERVE_MAIN = 'observe',
    OBSERVE_ROOM = 'observeRoom',
    OBSERVE_CAMERA = 'observeCamera',
    OBSERVE_SHARED_ROOM = 'observeSharedRoom',
    OBSERVE_SHARED_CAMERA = 'observeSharedCamera',
    OBSERVE_ROOM_COMMENTS = 'observeRoomComments',
    /* review */
    REVIEW_MAIN = 'review',
    REVIEW_LIST = 'reviewList',
    REVIEW_THUMBNAILS = 'reviewThumbnails',
    REVIEW_RECORD_SHOW = 'recordShow',
    REVIEW_RECORD_SHOW_COMMENT = 'recordShowComment',
    REVIEW_RECORD_SHOW_CAMERA = 'recordShowCamera',
    REVIEW_RECORD_SHOW_CAMERA_COMMENT = 'recordShowCameraComment',
    REVIEW_RECORD_SHARED_SHOW = 'recordSharedShow',
    REVIEW_RECORD_SHARED_SHOW_COMMENT = 'recordSharedShowComment',
    REVIEW_RECORD_SHARED_SHOW_CAMERA = 'recordSharedShowCamera',
    REVIEW_RECORD_SHARED_SHOW_CAMERA_COMMENT = 'recordSharedShowCameraComment',
    REVIEW_UPLOAD_LINK = 'recordUploadLink',
    REVIEW_PLAYLIST_VIEW = 'playlistView',
    /* alerts */
    ALERTS = 'alerts',
    /* schedule */
    SCHEDULE_MAIN = 'schedule',
    SCHEDULE_LIST = 'scheduleList',
    SCHEDULE_CALENDAR = 'scheduleCalendar',
    /* reports */
    REPORT_ROOT = 'report',
    REPORT_LIST = 'reportList',
    REPORT_TILES = 'reportTiles',
    REPORT_VIEW = 'reportView',
    /* admin */
    ADMIN_MAIN = 'admin',
    ADMIN_SERVERS = 'adminServers',
    ADMIN_GENERAL = 'adminGeneral',
    /* adminUser */
    ADMIN_USER = 'adminUser',
    ADMIN_USER_LIST = 'adminUserList',
    ADMIN_USER_VIEW = 'adminUserView',
    ADMIN_USER_NEW = 'adminUserNew',
    ADMIN_GROUP_LIST = 'adminGroupList',
    ADMIN_GROUP_VIEW = 'adminGroupView',
    ADMIN_GROUP_NEW = 'adminGroupNew',
    ADMIN_LDAP = 'adminLdap',
    ADMIN_ADD_LDAP_SERVER = 'adminAddLdapServer',
    ADMIN_EDIT_LDAP_SERVER = 'adminEditLdapServer',
    ADMIN_ADD_LDAP_SYNC = 'adminAddLdapSync',
    ADMIN_EDIT_LDAP_SYNC = 'adminEditLdapSync',
    ADMIN_SSO = 'adminSso',
    /* adminTemplate */
    ADMIN_TEMPLATE = 'adminTemplate',
    ADMIN_TEMPLATE_LIST = 'adminTemplateList',
    ADMIN_TEMPLATE_VIEW = 'adminTemplateView',
    ADMIN_TEMPLATE_NEW = 'adminTemplateNew',
    /* adminDeviceAndRoom */
    ADMIN_DEVICE = 'adminDevice',
    ADMIN_DEVICE_LIST = 'adminDeviceList',
    ADMIN_CAMERA_NEW = 'adminCameraNew',
    ADMIN_CAMERA_VIEW = 'adminCameraView',
    ADMIN_ROOM_NEW = 'adminRoomNew',
    ADMIN_ROOM_VIEW = 'adminRoomView',

    ADMIN_BEAM_DEVICE_NEW = 'adminBeamDeviceNew',
    ADMIN_BEAM_DEVICE_VIEW = 'adminBeamDeviceView',

    ADMIN_ROAM_DEVICE_NEW = 'adminRoamDeviceNew',
    ADMIN_ROAM_DEVICE_VIEW = 'adminRoamDeviceView',


    ADMIN_STREAM_NEW = 'adminStreamNew',
    ADMIN_STREAM_VIEW = 'adminStreamView',
    /* adminContainer */
    ADMIN_CONTAINER = 'adminContainer',
    ADMIN_CONTAINER_LIST = 'adminContainerList',
    ADMIN_CONTAINER_VIEW = 'adminContainerView',
    ADMIN_CONTAINER_NEW = 'adminContainerNew',
    ADMIN_SESSION_TRACK = 'adminSessionTrack',
    ADMIN_SESSION_TRACK_LIST = 'adminSessionTrackList',
    ADMIN_SESSION_TRACK_NEW = 'adminSessionTrackNew',
    ADMIN_SESSION_TRACK_VIEW = 'adminSessionTrackView',
    ADMIN_SESSION_NEW = 'adminSessionNew',
    ADMIN_SESSION_EDIT = 'adminSessionEdit',
    ADMIN_CIRCUIT = 'adminCircuit',
    ADMIN_CIRCUIT_LIST = 'adminCircuitList',
    ADMIN_CIRCUIT_NEW = 'adminCircuitNew',
    ADMIN_CIRCUIT_EDIT = 'adminCircuitEdit',
    ADMIN_CIRCUIT_VIEW = 'adminCircuitView',
    /* adminAnnouncement */
    ADMIN_ANNOUNCEMENT = 'adminAnnouncement',
    ADMIN_ANNOUNCEMENT_LIST = 'adminAnnouncementList',
    ADMIN_ANNOUNCEMENT_VIEW = 'adminAnnouncementView',
    ADMIN_ANNOUNCEMENT_NEW = 'adminAnnouncementNew',
    /* adminWowza */
    ADMIN_MEDIA_SERVER = 'adminMediaServers',
    ADMIN_MEDIA_SERVER_LIST = 'adminMediaServerList',
    ADMIN_MEDIA_SERVER_VIEW = 'adminMediaServerView',
    ADMIN_MEDIA_SERVER_NEW = 'adminMediaServerNew',
    // LDAP servers
    ADMIN_LDAP_SERVER_LIST = 'adminLdapServerList',
    ADMIN_LDAP_SERVER = 'adminLdapServer',
    ADMIN_LDAP_SERVER_VIEW = 'adminLdapServerView',
    ADMIN_LDAP_SERVER_NEW = 'adminLdapServerNew',
    /* SSO configs */
    ADMIN_SSO_CONFIG_LIST = 'adminSsoConfigList',
    ADMIN_SSO_CONFIG = 'adminSsoConfig',
    ADMIN_SSO_UPLOADED_CONFIG_VIEW = 'adminSsoUploadedConfigView',
    ADMIN_SSO_UPLOADED_CONFIG_NEW = 'adminSsoUploadedConfigNew',
    ADMIN_SSO_URL_CONFIG_VIEW = 'adminSsoUrlConfigView',
    ADMIN_SSO_URL_CONFIG_NEW = 'adminSsoUrlConfigNew',
    /* adminTranscribe */
    ADMIN_TRANSCRIPTION_SERVICE = 'adminTranscriptionService',
    ADMIN_TRANSCRIPTION_SERVICE_LIST = 'adminTranscriptionServiceList',
    ADMIN_TRANSCRIPTION_SERVICE_VIEW = 'adminTranscriptionServiceView',
    ADMIN_TRANSCRIPTION_SERVICE_NEW = 'adminTranscriptionServiceNew',
    /* adminLog */
    ADMIN_LOG_MAIN = 'adminLogMain',
    ADMIN_LOG_LOGIN = 'adminLogLogin',
    ADMIN_LOG_OBSERVE = 'adminLogObserve',
    ADMIN_LOG_RECORDING = 'adminLogRecording',
    ADMIN_LOG_REVIEW = 'adminLogReview',
    ADMIN_LOG_SCHEDULE = 'adminLogSchedule',
    ADMIN_LOG_REPORTS = 'adminLogReports',
    ADMIN_LOG_UPLOAD = 'adminLogUpload',
    ADMIN_LOG_ADMIN = 'adminLogAdmin',
    /* adminHelp */
    ADMIN_HELP = 'adminHelp',
    ADMIN_HELP_LIST = 'adminHelpList',
    ADMIN_HELP_VIEW = 'adminHelpView',
    ADMIN_HELP_NEW = 'adminHelpNew',
    ADMIN_HELP_CONTACT_NEW = 'adminHelpContactNew',
    ADMIN_HELP_CONTACT_EDIT = 'adminHelpContactEdit',
    ADMIN_HELP_CONTACT_CLONE = 'adminHelpContactClone',
    ADMIN_HELP_CONTACT_DELETE = 'adminHelpContactDelete',

    /* user settings */
    USER_SETTINGS = 'user_settings',
    NOTIFICATIONS = 'notifications',
    NOTIFICATIONS_ALL = 'notificationsAll',
    NOTIFICATIONS_REPLY = 'notificationsReply',
    NOTIFICATIONS_TAG = 'notificationsTag',
    NOTIFICATIONS_SHARING = 'notificationsSharing',
    NOTIFICATIONS_UPLOAD_LINK = 'notificationsUploadLink',
    NOTIFICATIONS_AUDIO = 'notificationsAudio',
    NOTIFICATIONS_CONVERSION = 'notificationsConversion',
    NOTIFICATIONS_MULTIVIEW = 'notificationsMultiview',
    NOTIFICATIONS_TRANSCRIPTION = 'notificationsTranscription',
    HELP = 'help',
    NO_ACCESS = 'noAccess',
    LOGOUT = 'logout',
    ERROR_PAGE = 'error_page',
    /* Calendar configs */
    ADMIN_CALENDAR_CONFIG_LIST = 'adminCalendarConfigList',
    ADMIN_CALENDAR_CONFIG = 'adminCalendarConfig',
    ADMIN_CALENDAR_CONFIG_VIEW = 'adminCalendarConfigView',
    ADMIN_CALENDAR_CONFIG_NEW = 'adminCalendarConfigNew',
}

export default ROUTE_NAMES;
